import React, { Component, PropTypes } from 'react'
import styles from './index.css'

export default class Ring extends Component {
  static propTypes = {
    radius: PropTypes.number.isRequired,
    ringWidth: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
    color: PropTypes.string,
    background: PropTypes.string,
    cap: PropTypes.oneOf(['butt', 'round', 'square'])
  }

  static defaultProps = {
    color: '#39f',
    background: '#f5f5f5',
    cap: 'butt'
  }

  componentDidMount () {
    this.draw()
  }

  componentDidUpdate () {
    this.draw()
  }

  draw () {
    const ctx = this.canvas.getContext('2d')
    const { percent, color, background, cap } = this.props
    const radius = 2 * this.props.radius
    const ringWidth = 2 * this.props.ringWidth

    // clear
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

    // set line style
    ctx.lineWidth = ringWidth
    ctx.lineCap = cap

    // draw background ring
    ctx.beginPath()
    ctx.strokeStyle = background
    ctx.arc(this.canvas.width / 2, this.canvas.height / 2, radius, 0, 2 * Math.PI)
    ctx.stroke()

    // draw foreground ring
    ctx.beginPath()
    ctx.strokeStyle = color
    ctx.arc(this.canvas.width / 2, this.canvas.height / 2, radius, -Math.PI / 2, percent / 100 * 2 * Math.PI - Math.PI / 2)
    ctx.stroke()
  }

  render () {
    const { radius, ringWidth, children } = this.props
    const size = 2 * radius + ringWidth

    return (
      <div style={{ width: size, height: size }} className={ styles.root }>
        <canvas
          ref={ el => this.canvas = el }
          width={ size * 2 }
          height={ size * 2 }>
        </canvas>
        { children ? <div className={ styles.children }>{ children }</div> : null }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Ring/index.js
 **/